/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('modal.show', function (e) {
        e.modal.element.parentElement.parentElement.parentElement.classList.add('paralogis-entrence');
        site.maxHeight.init();
    });
    MoyaEventHandler.on('modal.hide', function (e) {
        e.modal.element.parentElement.parentElement.parentElement.classList.remove('paralogis-entrence');
        e.modal.element.parentElement.parentElement.parentElement.classList.add('paralogis-exit');
        e.modal.element.parentElement.parentElement.parentElement.parentElement.classList.add('paralogis-is-open');
        setTimeout(function () {
            e.modal.element.parentElement.parentElement.parentElement.parentElement.classList.remove('paralogis-is-open');
        }, e.options.closingDelay);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
